import { formatNumberMix } from '@/utils'
import { _local } from '@/utils/storage'
import store from '@/store/index'
export default {
  data() {
    return {
      columns: [
        { prop: 'brandName', label: this.$t('operate-analysis::order-analysis::独立站'), minWidth: '200px' },
        { prop: 'orderNo', label: this.$t('operate-analysis::order-analysis::店铺订单编号'), minWidth: '250px' },
        { prop: 'product', label: this.$t('operate-analysis::order-analysis::商品'), minWidth: '120px' },
        { prop: 'grandTotalUsd', label: this.$t('operate-analysis::order-analysis::成交额'), minWidth: '160px' },
        { prop: 'customer', label: this.$t('operate-analysis::order-analysis::顾客'), minWidth: '160px' },
        { prop: 'country', label: this.$t('operate-analysis::order-analysis::国家'), minWidth: '160px' },
        { prop: 'channel', label: this.$t('operate-analysis::order-analysis::渠道'), minWidth: '160px' },
        { prop: 'orderStatus', label: this.$t('operate-analysis::order-analysis::订单状态'), minWidth: '160px' },
        { prop: 'payDate', label: this.$t('operate-analysis::order-analysis::订单支付时间'), minWidth: '200px' },

      ]
    }
  },
  methods: {
    formatNumberMix,
    setOrderOverview(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: this.$t('operate-analysis::order-analysis::今日新增订单'),
        number: data && this.$dataCheck(formatNumberMix(data.increOrderNum, 0, ',')),
        down: data && data.increOrderRate ? data.increOrderRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.increOrderRate, 2, '', '')),
      }
      list[1] = {
        title: this.$t('operate-analysis::order-analysis::今日客单价'),
        number: data && this.$dataCheck(formatNumberMix(data.customerPrice, 2, ',')),
        down: data && data.customerPriceRate ? data.customerPriceRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.customerPriceRate, 2, '', '')),
      }
      list[2] = {
        title: this.$t('operate-analysis::order-analysis::待发货订单'),
        number: data && this.$dataCheck(formatNumberMix(data.waitShipOrderNum, 0, ',')),
        down: data && data.waitShipOrderRate ? data.waitShipOrderRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.waitShipOrderRate, 2, '', '')),
        hideRate: true
      }
      list[3] = {
        title: this.$t('operate-analysis::order-analysis::超时待发货'),
        tipTargetElemnt: '#boardShowWrap .month-report-wrap',
        visible: Boolean(isNaN((_local.get('report_local') || {}).orderAnalysis) ? 1 : (_local.get('report_local') || {}).orderAnalysis),
        tipCallback: (data) => {
          data.visible = !data.visible
          let local = _local.get('report_local') || {}
          local.orderAnalysis = Number(data.visible)
          store.dispatch('updateUserInfoConfig', local)
        },
        tip: h => h('span', [
          this.$t('operate-analysis::order-analysis::点击页面管理icon即可设置企业相关指标'),
          h(
            'a',
            {
              on: {
                click: () => {
                  data.visible = !data.visible
                  let local = _local.get('report_local') || {}
                  local.order_analysis = Number(data.visible)
                  store.dispatch('updateUserInfoConfig', local)
                }
              }
            }
          ),
        ]),
        number: data && this.$dataCheck(formatNumberMix(data.outTimeOrderNum, 0, ',')),
        down: data && data.outTimeOrderRate ? data.outTimeOrderRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.outTimeOrderRate, 0, '', '')),
        setting: true,
        hideRate: true
      }
      list[4] = {
        title: this.$t('operate-analysis::order-analysis::待确认收货'),
        number: data && this.$dataCheck(formatNumberMix(data.unreceiptOrderNum, 0, ',')),
        down: data && data.unreceiptOrderRate ? data.unreceiptOrderRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.unreceiptOrderRate, 2, '', '')),
        hideRate: true
      }
      return list
    },
    setLogisticsOverview(data) {
      let list = new Array(3).fill(null)
      list[0] = {
        title: this.$t('operate-analysis::order-analysis::平均发货时长(天)'),
        count: data && this.$dataCheck(formatNumberMix(data.shipDaysAvg, 2, ',')),
        down: data && data.shipDaysAvgRate ? Number(data.shipDaysAvgRate) < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.shipDaysAvgRate, 2, '', '')),
        tooltip: this.$t('operate-analysis::order-analysis::deliver_tooltip'),
        noDetail: true
      }
      list[1] = {
        title: this.$t('operate-analysis::order-analysis::平均配送时长(天)'),
        count: data && this.$dataCheck(formatNumberMix(data.deliveryDayAvg, 2, ',')),
        down: data && data.deliveryDayAvgRate ? data.deliveryDayAvgRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.deliveryDayAvgRate, 2, '', '')),
        tooltip: this.$t('operate-analysis::order-analysis::send_tooltip'),
        noDetail: true
      }
      list[2] = {
        title: this.$t('operate-analysis::order-analysis::超时后平均发货时长'),
        count: data && this.$dataCheck(formatNumberMix(data.outtimeShipdaysAvg, 2, ',')),
        down: data && data.outtimeShipdaysRate ? data.outtimeShipdaysRate < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.outtimeShipdaysRate, 2, '', '')),
        tooltip: this.$t('operate-analysis::order-analysis::outTime_tooltip'),
        noDetail: true
      }
      return list
    },
    setDeliverConfig(data = []) {
      return {
        type: 'bar',
        title: this.$t('operate-analysis::order-analysis::发货时效分布'),
        ref: 'deliverBar',
        btns: [
          { icon: 'icona-03shezhi', call: 'setting', type: 'deliver' },
        ],
        height: '382px',
        chart: {
          xAxis: {
            data: data.map(item => item.dataDate + this.$t('operate-analysis::order-analysis::天'))
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#9DA1C3'
              }
            }
          ],
          series: [
            {
              name: this.$t('operate-analysis::order-analysis::订单'),
              type: 'bar',
              data: data.map(item => Number(item.orderNum))
            }
          ]
        }
      }
    },
    setPerformConfig(data = []) {
      return {
        type: 'bar',
        title: this.$t('operate-analysis::order-analysis::履约时效分布'),
        btns: [
          { icon: 'icona-03shezhi', call: 'setting', type: 'perform' },
        ],
        ref: 'performBar',
        height: '382px',
        chart: {
          xAxis: {
            data: data.map(item => item.dataDate + this.$t('operate-analysis::order-analysis::天'))
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#9DA1C3'
              }
            }
          ],
          series: [
            {
              name: this.$t('operate-analysis::order-analysis::订单'),
              type: 'bar',
              data: data.map(item => Number(item.orderNum))
            }
          ]
        }
      }
    }
  }
}
